import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { APP_CONST } from "../../store/dataStore";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import { dateFormatter, moneyTableViewFormatter } from "../../util/formatter";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

const rielStyle = {
  position: "relative",
  top: "0.15rem",
  fontSize: "1.15rem",
};

class TransactionsTable extends Component {
  viewFormatter = (cell, row) => {
    const pathMap = {
      incoming: "/view_incoming_transaction/",
      outgoing: "/view_outgoing_transaction/",
    };

    const { type } = this.props;
    const { sourceAccountId, fiTransactionId } = row;
    const pathname = `${pathMap[type]}${sourceAccountId}/${fiTransactionId}`;

    return (
      <Link
        to={{
          pathname,
          state: { data: row, previousLocation: { ...this.props.location } },
        }}>
        <div>
          <i
            className="fa fa-search"
            style={{ color: "#D15050" }}
            data-cy="view-tx"
          />
        </div>
      </Link>
    );
  };

  currencyFormatter(amount, row) {
    const isWindows = navigator.appVersion.indexOf("Win") !== -1;
    return row.currencyName === "KHR" ? (
      <>
        <span style={isWindows ? rielStyle : {}}>{APP_CONST.RIEL_SYMBOL}</span>
        {moneyTableViewFormatter(amount, row)}
      </>
    ) : (
      moneyTableViewFormatter(amount, row)
    );
  }

  render() {
    return (
      <BootstrapTable
        data={this.props.data}
        options={this.props.options}
        fetchInfo={this.props.fetchInfo}
        headerStyle={headerStyle}
        version="4"
        search={this.props.search}
        pagination
        striped
        hover
        condensed
        remote
        exportCSV={!this.props.isAuditor}>
        <TableHeaderColumn
          dataFormat={this.viewFormatter}
          dataField="view"
          width="60"
          dataAlign="center">
          View
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="transactionHash"
          width="200"
          isKey>
          Trx Hash
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataFormat={dateFormatter}
          dataField="transactionCreatedTime"
          width="160">
          Entry Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="sourceAccountId" width="150">
          From Account
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="destinationAccountId"
          width="150">
          To Account
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="currencyName"
          width="70"
          dataAlign="center">
          CCY
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={this.currencyFormatter}
          width="100"
          dataAlign="right">
          Amount
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="status"
          width="150"
          dataAlign="right">
          Status
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }
}

TransactionsTable.defaultProps = {
  search: true,
};

TransactionsTable.propTypes = {
  data: PropTypes.array,
  options: PropTypes.object,
  fetchInfo: PropTypes.object,
  search: PropTypes.bool,
  location: PropTypes.object.isRequired,
  isAuditor: PropTypes.bool,
  type: PropTypes.oneOf(["incoming", "outgoing"]).isRequired,
};

export default withRouter(TransactionsTable);
